import { queryStringify } from '@utils'
import { createRequestHelper } from '@utils/swr'
import { type MerchantsSearchRequest } from '../types/apiRequest'
import { type MerchantsSearchResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const { useRequest }
= createRequestHelper<FortuneApis['get']['searchMerchants'], MerchantsSearchResponse, MerchantsSearchRequest>({
  client: 'fortune',
  key: (params) => {
    if (!params) return null
    const { platform, project_code, query, user_id } = params
    if (!platform || !project_code || !query || !user_id) return null
    return `/merchants/search?${queryStringify(params)}`
  },
})

export const useApiMerchantsSearch = useRequest
